import React, { useMemo, useState } from "react";
import * as styles from "./Select.module.css";

const Select = (props) => {
  const {
    options,
    id,
    label,
    name,
    value,
    defaultValue,
    handleChange,
    required,
    disabled,
    hasMarginTop,
    selected,
    isSmall,
    isGameScore,
    noDefaultSelect,
    variant,
  } = props;

  const [data, setData] = useState(value);

  const [select, setSelect] = useState(selected);

  useMemo(() => {
    setSelect(selected);
  }, [selected]);

  const handleUpdate = (e) => {
    setData(e.target.value);
    handleChange(e.target.value, e.target.id);
  };

  return (
    <div
      className={`${styles.form_group} ${
        hasMarginTop ? styles.hasMarginTop : null
      } ${isSmall ? styles.isSmall : null}`}
    >
      <label className={styles.label} htmlFor={id}>
        {label}
      </label>
      <select
        className={`${styles.select} ${styles[variant]}`}
        name={name}
        id={id}
        onChange={handleUpdate}
        value={select}
        defaultValue={defaultValue || select || null}
        required={required || null}
        disabled={disabled || null}
      >
        {!noDefaultSelect && <option value="">Select...</option>}
        {options.map((option, index) =>
          isGameScore ? (
            <option key={index} value={option.value}>
              {option.name}
            </option>
          ) : (
            <option
              key={index}
              value={option.value || option.name || option.title || option}
            >
              {option.value || option.name || option.title || option}
            </option>
          )
        )}
      </select>
    </div>
  );
};

export default Select;
